export const removeSpacesAndCharacters = (str: string): string =>
  str.replace(/[\s'%&]/g, '')
